import { Organisation, OrganisationType } from '../types/organisation';
import { RoleName, UserRole } from '../types/user';

/**
 * Check if organization is a Family Organization
 */
export function isFamilyOrganization(organization?: Organisation | null): boolean {
	if (!organization) return false;
	return organization.type === OrganisationType.Company && organization.license === 'Family';
}

/**
 * Check if organization is verifier only
 */
export function isVerifierOnlyOrg(organization?: Organisation | null): boolean {
	if (!organization) return false;
	return organization.type === OrganisationType.Company && organization.license === 'verifier only org';
}

/**
 * Check if organization is a standard company (not family, not verifier only)
 */
export function isStandardCompany(organization?: Organisation | null): boolean {
	if (!organization) return false;
	return (
		organization.type === OrganisationType.Company &&
		!isFamilyOrganization(organization) &&
		!isVerifierOnlyOrg(organization)
	);
}

/**
 * Check if user can manage family members
 */
export function canManageFamilyMembers(organisation?: Organisation | null, userRoles?: UserRole[]): boolean {
	if (!isFamilyOrganization(organisation) || !userRoles) return false;

	return userRoles.some(
		(role) => role.roleName === RoleName.FamilyOrganisationAdmin && role.organisationId === organisation?.id
	);
}

/**
 * Check if user is a family member in an organization
 */
export function isFamilyMember(organisation?: Organisation | null, userRoles?: UserRole[]): boolean {
	if (!isFamilyOrganization(organisation) || !userRoles) return false;

	return userRoles.some(
		(role) => role.roleName === RoleName.FamilyMember && role.organisationId === organisation?.id
	);
}

/**
 * Get all roles for an organization
 */
export function getOrganizationRoles(organisationId: string, userRoles?: UserRole[]): UserRole[] {
	if (!userRoles) return [];
	return userRoles.filter((role) => role.organisationId === organisationId);
}
